import "jquery";
import * as ko from "knockout";
import { LatestDocumentsViewModel } from "../ViewModels/LatestDocumentsViewModel";
import { PdfApi } from "../Apis/PdfApi";
import "footable-npm";

export class LatestDocuments {
    latestDocumentsViewModel: LatestDocumentsViewModel;
    $viewModelAnchor: JQuery;
    pdfApi: PdfApi;
    $downloadId: JQuery;

    constructor() {
        this.pdfApi = PdfApi.getInstance();
        this.latestDocumentsViewModel = new LatestDocumentsViewModel();
        this.$viewModelAnchor = $('#dashboard-documents');
        if (this.$viewModelAnchor[0]) {
            ko.applyBindings(this.latestDocumentsViewModel, this.$viewModelAnchor[0]);
        }
    }
    init(): void {
        this.pdfApi.getNewestPdfs().then((res) => {
            this.latestDocumentsViewModel.allDocuments(res.slice().sort((a, b) => b.DateAndTime.getTime() - a.DateAndTime.getTime()));
            this.latestDocumentsViewModel.latestDocuments((this.latestDocumentsViewModel.allDocuments() as any).slice(0, 5));
            ($('#table-documents-expanded') as any).footable();

            this.latestDocumentsViewModel.expanded(false);

            ($('#table-documents') as any).footable();
            this.latestDocumentsViewModel.isLoading(false);
            this.attachPdfDownloadJquery();

        });
    }

    private attachPdfDownloadJquery(): void {
        const self = this;
        self.$viewModelAnchor.on('click', '[id *= download]', function (e: any) {
            const id = $(this).attr('id');
            const fileName = $(this).attr('filename');
            const entryNo = Number.parseInt(id.split('download')[1]);
            const company = $(this).attr('company');
            self.pdfApi.downloadFile(entryNo, fileName, company);
        });
    }

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}